import type { FC } from 'react';
import { Fragment } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

interface Props {
  nbLines?: number;
  collapsed?: boolean;
}

const SQUARE_SIZE = 15;
const PADDING_LEFT = 50;
const LINE_POSITION = PADDING_LEFT + SQUARE_SIZE + 35;
const LINE_LENGTH = 182;

function getTopPosition(lineIndex: number): number {
  return SQUARE_SIZE * lineIndex * 2;
}

const VideogameTreePlaceholder: FC<Props> = ({ nbLines = 3, collapsed = false }) => (
  <ContentLoader>
    {createArray(nbLines).map((_, index) => {
      const y = getTopPosition(index);
      return (
        <Fragment key={index}>
          <rect x={PADDING_LEFT} y={y} width={SQUARE_SIZE} height={SQUARE_SIZE} />
          {!collapsed && <rect x={LINE_POSITION} y={y} width={LINE_LENGTH} height={SQUARE_SIZE} />}
        </Fragment>
      );
    })}
  </ContentLoader>
);

VideogameTreePlaceholder.displayName = 'VideogameTreePlaceholder';

export default VideogameTreePlaceholder;
